import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';

const Wrapper = styled.div`
  height: ${rem(40)};
  width: ${rem(460)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: ${rem(3)};
  margin-top: ${rem(30)};
  @media (max-width: ${rem(500)}) {
    width: ${rem(400)};
  }
  @media (max-width: ${rem(400)}) {
    width: ${rem(350)};

  }


`;

const Title = styled.div`
  font-size: ${rem(14)};
  justify-content: center;
  align-items: center;
`;

const InformationMessage = ({ className, title, type, theme }) => {
  let boxColor = '';
  let titleColor = '';
  if (type === 'info') {
    boxColor = 'rgba(74,150,214,0.1)';
    titleColor = theme.color.info;
  } else if (type === 'warning') {
    boxColor = 'rgba(219,23,63,0.1)';
    titleColor = theme.color.primary;
  }
  return (
    <Wrapper style={{ background: boxColor }} className={className}>
      <Title style={{ color: titleColor }}>{title}</Title>
    </Wrapper>
  );
};

InformationMessage.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.shape({
    color: PropTypes.shape({}).isRequired,
  }).isRequired,
  type: PropTypes.string,

  title: PropTypes.string,
};
InformationMessage.defaultProps = {
  className: '',
  title: '',
  type: '',
};

export default withTheme(InformationMessage);



// WEBPACK FOOTER //
// ./src/components/InformationMessage/index.js